
import { form5StatusInfoType } from '@/types/Information/Form5';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form5ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form5StatusInfoType;

}
